module.exports = __webpack_public_path__ + "img/menu-sendcard.ef64ed39.png";